import { useQuery } from "@tanstack/react-query";
import { axiosCoreInstance } from "src/config/axios";
import { CompanyListModel } from "../types/Company";

export const RQ_COMPANY_LIST_KEY = "AUTH_COMPANY_LIST";

export const fetchCompanyList = async (): Promise<CompanyListModel[]> => {
    const res = await axiosCoreInstance.get("api/company");

    return res?.data || null;
};

export const useCompanyList = () => {
    return useQuery([RQ_COMPANY_LIST_KEY], fetchCompanyList, { enabled: false });
};
